// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"d52fe258","436":"57bc91a9","1968":"fa2240ad","3237":"c4d28f59","6761":"0434a9ea","9989":"352708c2"}[chunkId] + ".chunk.css";
};